import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Moment from 'react-moment';
import './joblistitem.scss';
import moment from 'moment-timezone';


function JobListItem({ job}) {
    
    return (
        <>
            <div className='job-content' >
                <div className='job-content-header' >
                    <Row>
                        <Col md='12'>
                            <div className='job-data'>
                                <span className='sm-contents'>{job.id}</span>
                                <div className='sm-breaker'></div>

                                <span className='lg-contents'> {job.name}</span>
                                <div className='lg-breaker'></div>

                                <span className='md-contents'>{job.ruleName}</span>
                                <div className='md-breaker'></div>

                                <span className={`md-contents ${job.statusText === 'Failed' ? 'failed-status' : ''}`}>{job.statusText}</span>
                                <div className='md-breaker'></div>

                                <span className='lg-contents'>{job.startDateTime ?moment(job.startDateTime).tz('America/Chicago').format('YYYY-MM-DD HH:mm:ss z'):""}</span>
                                <div className='lg-breaker'></div>

                                <span className='lg-contents'>{job.endDateTime ? moment(job.endDateTime).tz('America/Chicago').format('YYYY-MM-DD HH:mm:ss z'):""}</span>
                               

                                                                                   
                            </div>
                        </Col>        
                    </Row>

                </div>
           </div>

            
        </>
    )
}



export default JobListItem;